<template>
  <i-override-dialog
    rtl
    modal
    dismissableMask
    v-model:visible="optionsModal"
    :title="__('Where do you want to upload a photo from?')"
  >
  <div class="p-d-flex p-jc-center" style="direction:ltr;">
    <i-override-select-button
      v-model="getImg"
      :options="getImgOptions"
      option-label="name"
    ></i-override-select-button>
  </div>
  </i-override-dialog>
</template>

<script>
import { __ } from "@/plugins/i18n/index";

export default {
  plugins: { __ },
  emints: ["getImage"],
  data() {
    return {
      SourceType: null,
      optionsModal: false,
      getImgOptions: [
        { name: __("Camera"), value: 1 },
        { name: __("Gallery"), value: 0 },
      ],
      getImg: null,
    };
  },
  mounted() {
    if (window.cordova.platformId === "browser") {
      this.SourceType = window.navigator.camera.PictureSourceType.PHOTOLIBRARY;
      this.$emit("getImage", this.SourceType);
    } else this.optionsModal = true;
  },
  methods: {},
  watch: {
    getImg() {
      this.optionsModal = false;
      if (this.getImg.value == 0)
        this.SourceType =
          window.navigator.camera.PictureSourceType.PHOTOLIBRARY;
      else this.SourceType = window.navigator.camera.PictureSourceType.CAMERA;
      this.$emit("getImage", this.SourceType);
    },
  },
};
</script>

